import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { HOST } from 'config/config';
import tableDataQueryStringBuilder from 'services/Utilities/TableData';
import useToast from 'services/Hooks/useToast';

export const useAllInventoryItems = () => {
  const query = useQuery({
    queryKey: ['allInventoryItems'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/inventory-items/all');
      return response.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchInterval: false,
    refetchOnMount: false,
  });
  return query;
};

export const useInventoryItems = tableDataParam => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['inventoryItems', JSON.stringify(tableDataParam)],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/inventory-items', {
        paramsSerializer: params => tableDataQueryStringBuilder(params),
        params: tableDataParam,
      });
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
  return query;
};

export const usePromotionInventoryItems = tableDataParam => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['inventoryItems', JSON.stringify(tableDataParam)],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/inventory-items/promotions', {
        paramsSerializer: params => tableDataQueryStringBuilder(params),
        params: tableDataParam,
      });
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
  return query;
};

export const useEditableInventoryItems = () => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['editableInventoryItems'],
    queryFn: async () => {
      const response = await axios.get(HOST + `/api/dealer-portal/inventory-items/editable-inventory-items`);

      return response.data;
    },
    throwOnError: errorMessage,
  });
  return query;
};

export const useInventoryItem = (id, forcedFetch = false) => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['inventoryItem', id],
    queryFn: async () => {
      const response = await axios.get(HOST + `/api/dealer-portal/inventory-items/${id}`);
      return response.data;
    },
    placeholderData: id === 'create' ? { id: uuidv4() } : undefined,
    enabled: id !== 'create',
    staleTime: forcedFetch ? 0 : Infinity,
    throwOnError: errorMessage,
  });
  return query;
};
